import * as React from 'react';

interface DetailCardProps {
  title?: string;
  titleAction?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function DetailCard({ title, titleAction, children, className = '' }: DetailCardProps) {
  return (
    <div className={`bg-card rounded-lg border border-border p-4 ${className}`}>
      {(title || titleAction) && (
        <div className="flex items-center justify-between mb-3">
          {title && (
            <h3 className="text-secondary font-semibold text-base">{title}</h3>
          )}
          {titleAction}
        </div>
      )}
      {children}
    </div>
  );
}
